import React from "react"
import { Empty, Tooltip } from "antd"
import styled from "styled-components"
import { COLORS, formatPoints } from "./format"

const HEIGHT = 220

// Начисления вверх от оси, списания и сгорания вниз — по периоду столбик.
// Без библиотеки графиков: столбиков не больше нескольких сотен, хватает SVG.
export function PointsBarChart({ rows = [] }) {
  if (rows.length === 0) {
    return <Empty description="Нет операций за период" />
  }

  const maxUp = Math.max(1, ...rows.map((row) => row.accrued))
  const maxDown = Math.max(1, ...rows.map((row) => row.written_off + row.burned))
  const scale = (HEIGHT - 20) / (maxUp + maxDown)
  const axis = 10 + maxUp * scale
  const barWidth = Math.max(4, Math.min(40, Math.floor(900 / rows.length) - 4))
  const width = rows.length * (barWidth + 4) + 8

  return (
    <ChartWrapper>
      <svg width={width} height={HEIGHT} role="img" aria-label="Начисления и списания по периодам">
        <line x1={0} x2={width} y1={axis} y2={axis} stroke="#d9d9d9" />
        {rows.map((row, index) => {
          const x = 4 + index * (barWidth + 4)
          const up = row.accrued * scale
          const writtenOff = row.written_off * scale
          const burned = row.burned * scale

          return (
            <Tooltip
              key={row.date}
              title={
                <>
                  <div>{row.date}</div>
                  <div>Начислено: {formatPoints(row.accrued)}</div>
                  <div>Списано: {formatPoints(row.written_off)}</div>
                  {row.burned > 0 && <div>Сгорело: {formatPoints(row.burned)}</div>}
                  <div>Итог: {formatPoints(row.net)}</div>
                </>
              }
            >
              <g>
                <rect x={x} y={axis - up} width={barWidth} height={up} fill={COLORS.accrued} />
                <rect x={x} y={axis} width={barWidth} height={writtenOff} fill={COLORS.writtenOff} />
                <rect x={x} y={axis + writtenOff} width={barWidth} height={burned} fill={COLORS.burned} />
              </g>
            </Tooltip>
          )
        })}
      </svg>
      <Legend>
        <span><Dot color={COLORS.accrued} />Начислено</span>
        <span><Dot color={COLORS.writtenOff} />Списано</span>
        <span><Dot color={COLORS.burned} />Сгорело</span>
      </Legend>
    </ChartWrapper>
  )
}

const ChartWrapper = styled.div`
  overflow-x: auto;
  margin-bottom: 16px;
`

const Legend = styled.div`
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #595959;
`

const Dot = styled.i`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
  background: ${({ color }) => color};
`
